import * as React from 'react';

import { IGetImageSchema } from '../../repositories/special-promos/entities/schemas/GetImageSchema';
import { IGetBannerSchema } from '../../repositories/special-promos/entities/schemas/GetBannerSchema';

import classNames from 'classnames';

import { formatUrl } from '../../utils/formatters';
import { Slider } from './slider';
import { Marquee } from '../marquee';

import * as styles from './index.css';

interface IBannerProps {
  banners: IGetBannerSchema[];
  logo: IGetImageSchema;
}

export class Banners extends React.PureComponent<IBannerProps, object> {
  public render() {
    if (this.props.banners.length === 0) {
      return null;
    }

    return (
      <div className={styles['banner']}>
        <Slider slides={this.createSlides(this.props)} />
      </div>
    );
  }

  private createSlides = ({ banners, logo }: IBannerProps) =>
    // eslint-disable-next-line react/display-name
    banners.map(banner => (visible: boolean) => (
      <div
        key={banner.id}
        className={classNames(visible ? styles['slide'] : styles['invisible'])}
        style={{
          backgroundImage: `url(${banner.image?.url})`,
        }}
      >
        <div className={styles['content']}>
          {/* перехватываем событие, чтобы можно было выделять текст */}
          <div onClick={e => e.stopPropagation()}>
            <img src={logo.url ?? ''} className={styles['logo']} />
            <p className={styles['label']}>{banner.text}</p>
          </div>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={formatUrl(banner.urlLink)}
            className={classNames(styles['link'], 'iefix_button')}
          >
            {banner.textButton}
          </a>
        </div>

        {banner.disclaimer && (
          <div className={styles['disclaimer']}>
            <Marquee text={banner.disclaimer} />
          </div>
        )}
      </div>
    ));
}
